// projects.ts — Endpoints projets + risques projets.
import { req } from './_internals.js';

export const projectsApi = {
  getProjects: () => req('GET', '/projects'),
  createProject: (d: unknown) => req('POST', '/projects', d),
  getProject: (id: number | string) => req('GET', '/projects/' + id),
  updateProject: (id: number | string, d: unknown) => req('PUT', '/projects/' + id, d),
  deleteProject: (id: number | string) => req('DELETE', '/projects/' + id),
  getProjectRisks: (id: number | string) => req('GET', '/projects/' + id + '/risks'),
  createProjectRisk: (id: number | string, d: unknown) =>
    req('POST', '/projects/' + id + '/risks', d),
  updateProjectRisk: (pid: number | string, rid: number | string, d: unknown) =>
    req('PUT', '/projects/' + pid + '/risks/' + rid, d),
  deleteProjectRisk: (pid: number | string, rid: number | string) =>
    req('DELETE', '/projects/' + pid + '/risks/' + rid),
};
